export default __webpack_public_path__ + "static/media/roborovski-sign.32f0893a.png";